import { render, staticRenderFns } from "./CountryDiscrep.vue?vue&type=template&id=1fedaa4c"
import script from "./CountryDiscrep.vue?vue&type=script&lang=js"
export * from "./CountryDiscrep.vue?vue&type=script&lang=js"
import style0 from "./CountryDiscrep.vue?vue&type=style&index=0&id=1fedaa4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports